<template>
    <div style="width:100%">
        <v-form v-model="valid">
            <v-container fluid>
                <v-layout>
                    <v-flex md4>
                        <v-text-field label="Name"
                                      v-model="profile.name"
                                      :rules="premiseRules"
                                      counter="100"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-sheet
                        v-for="button in buttons"
                        class="d-flex mb-2"
                        color="grey lighten-3">
                    <v-container fluid style="width:100%">
                        <v-layout>
                            <v-flex md4 sm12>
                                <v-text-field label="Label"
                                              v-model="button.label"
                                              counter="100"
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 sm12>
                                <v-text-field label="Event Type"
                                              v-model="button.eventType"
                                              counter="100"
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 sm12>
                                <v-text-field label="CAD Event Type"
                                              v-model="button.cadEventType"
                                              counter="100"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex md4 sm12>
                                <v-text-field label="Incident Text"
                                              v-model="button.incidentText"
                                              counter="100"
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 sm12>
                                <v-text-field label="SMS Text"
                                              v-model="button.smsText"
                                              counter="100"
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 sm12>
                                <v-checkbox label="Send SMS"
                                              v-model="button.sendSms"
                                              counter="100"
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-divider class="py-2"></v-divider>
                </v-sheet>
                <v-layout>
                    <v-btn type="button" @click="save()" color="success" :disabled="overlay">Save</v-btn>
                    <v-progress-circular
                            :width="3"
                            v-show="overlay"
                            color="red"
                            indeterminate="">
                    </v-progress-circular>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>

    import api from '@/api';

    export default {

        data() {
            return {
                profile : {},
                buttons: [],
                valid   : true,
                overlay:false
            }
        },
        created() {
            api.profile.get(this.$route.params.profileId).then(p => this.profile = p);
            api.button.search({
               pageNumber:1,
               pageSize:-1,
               profileId:this.$route.params.profileId
            }).then(b => this.buttons = b.list);

        },
        methods: {
            save() {
                this.overlay = true;
                api.profile.patch(this.profile).then(p =>{
                    this.profile = p;
                    const buttonPromises = [];
                    this.buttons.forEach(button => {
                        buttonPromises.push(new Promise((resolve,reject) => {
                            api.button.patch(button).then(resolve());
                        }));
                    });
                    Promise.all(buttonPromises).then(() =>{
                        this.overlay = false;
                    }).catch(()=> {
                        alert('error');
                        this.overlay = false;
                    });
                }).catch(error => {
                    alert('error');
                    this.overlay = false;
                });
            }
        }

    }

</script>